var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3010_14128)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9056 7.87452C19.8117 7.51154 19.6276 7.18052 19.3716 6.91459C19.1156 6.64866 18.7969 6.45716 18.4472 6.35924C17.1599 6 12 6 12 6C12 6 6.84007 6 5.55285 6.35732C5.203 6.45493 4.88405 6.64633 4.62805 6.91231C4.37204 7.17828 4.18799 7.50947 4.09436 7.87261C3.75 9.21019 3.75 12 3.75 12C3.75 12 3.75 14.7898 4.09436 16.1255C4.28404 16.8631 4.84386 17.4439 5.55285 17.6408C6.84007 18 12 18 12 18C12 18 17.1599 18 18.4472 17.6408C19.158 17.4439 19.716 16.8631 19.9056 16.1255C20.25 14.7898 20.25 12 20.25 12C20.25 12 20.25 9.21019 19.9056 7.87452ZM10.361 14.5605V9.43949L14.6334 11.9809L10.361 14.5605Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3010_14128"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.37070af9678cfe21ddb6591ba039b8a0.svg";
export { ForwardRef as ReactComponent };